import styled from 'styled-components'

export const DetailsSubItemContainer = styled.div`
  margin-bottom: 3rem;

  h3 {
    font-size: 36px;
    color: var(--blue2);
    margin-right: 1.5rem;
  }

  img,
  video {
    max-width: 100%;
  }

  @media only screen and (max-width: 500px) {
    h3 {
      font-size: 24px;
    }
  }
`
